import { render, staticRenderFns } from "./App.vue?vue&type=template&id=a4f2f48a"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=a4f2f48a&prod&lang=sass"
import style1 from "./App.vue?vue&type=style&index=1&id=a4f2f48a&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports